import { Button, Dialog } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import './SpecialCommunities.scss';
import { http, localstorage } from '../fx-core';
import ConfirmDialog from '../ConfirmDialog/ConfirmDialog';
import { useDispatch } from 'react-redux';
import * as _ from 'lodash';

const SpecialCommunities = (props) => {
  const dispatch = useDispatch();
  const uid = localstorage.getItem('userId');
  const cid = localstorage.getItem("communityId")
  const userId = (uid && uid != null) ? parseInt(uid) : 0;
  const defaultCommId = (cid && cid != null) ? parseInt(cid) : 0;
  const displayCount = 5;

  const [allSplCommunityList, setAllSplCommunityList] = useState([]);
  const [splCommunityList, setSplCommunityList] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [selectedItem, setSelectedItem] = useState({ id: 0 });
  const [baseCommunity, setBaseCommunity] = useState({ id: 0, name: "" });
  const [currentStep, setCurrentStep] = useState(1);

  const handleClose = () => {
    props.handleDialogClose();
  };

  const showMore = () => {
    setCurrentStep(2);
  };

 const getSpecialCommunities = () => {
    let apiOptions: any = {
      url: `community/specialcommunity/${defaultCommId}`
    };
    http.get(apiOptions).then(res => {
      const result = res.data;

      // Filter out expired communities using endDateTime
      const now = new Date();
      const activeOnly = result.filter((item: any) => {
        if (!item.endDateTime) return true;
        const end = new Date(item.endDateTime);
        end.setHours(23, 59, 59, 999);
        return end >= now;
      });

      setAllSplCommunityList(activeOnly);
      const reducedItems: any = _.take(activeOnly, displayCount);
      setSplCommunityList(reducedItems);
    })
  };

  const getUserBaseCommunity = () => {
    let apiOptions: any = {
      url: `community/user/base`,
      data: {}
    };
    http.post(apiOptions).then(res => {
      const result = res.data;
      setBaseCommunity(result);
    })
  };

  const confirmSwitchCommunity = (event, item: any) => {
    setSelectedItem(item);
    setConfirmOpen(true);
    setMessage("Are you sure to switch to " + item.name + " community?");
    event.stopPropagation();
  };

  const onConfirmCallback = () => {
    setConfirmOpen(false);
    if (userId > 0) {
      switchCommunity();
    }
    else {
      switchCommunityWithoutLogin();
    }
  };

  const handleDialogClose = () => {
    setConfirmOpen(false);
  };

  const switchCommunity = () => {
    let inputData = {
      communityId: selectedItem.id
    };
    let apiOptions: any = {
      url: `community/switch`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      const result = res.data;
      if (result && result.linkUrl) {
        window.open(result.linkUrl, '_self');
      }
      logoutUser();
    })
  };

  const switchCommunityWithoutLogin = () => {
    let inputData = {
      communityId: selectedItem.id
    };
    let apiOptions: any = {
      url: `community/switch/withoutlogin`,
      data: inputData
    };
    http.post(apiOptions).then(res => {
      const result = res.data;
      if (result && result.linkUrl) {
        window.open(result.linkUrl, '_self');
      }
    })
  };

  const logoutUser = () => {
    dispatch({ type: "LOGOUT", payload: { isLogin: false } });
    dispatch({ type: "CLEAR_CART", payload: {} });
    dispatch({ type: "CLEAR_LISTING_CART", payload: {} });
  }

  useEffect(() => {
    getSpecialCommunities();
    if (userId > 0) {
      getUserBaseCommunity();
    }
  }, []);


  return (
   <div className="special-communities pb-5 pt-3">
  {/* Close button */}
  <div className="float-right pr-3">
    <i
      className="fas fa-times-circle color-primary font-24 pointer"
      onClick={handleClose}
    ></i>
  </div>

  {/* STEP 1 */}
  {currentStep === 1 && (
    <div className="row justify-content-center mx-5 mt-5">
      <div className="col-12 text-center d-flex flex-column justify-content-between">
        <div>
          {/* ✅ Base Community */}
          {baseCommunity.id > 0 && baseCommunity.id !== defaultCommId && (
            <>
             
              <div className="font-weight-bold mt-5">Switch Community</div>
             <div
                className="mb-4 pointer"
                onClick={(e) => confirmSwitchCommunity(e, baseCommunity)}
              >
                 <div className="pt-4 spl-community-name font-14 pointer">
                {baseCommunity.name}
              </div>
              </div>
            </>
          )}

          {/* ✅ Special Communities */}
          {splCommunityList.length > 0 && (
            <>
              <div className="font-weight-bold mt-5">Special Community</div>

              {splCommunityList.map(
                (item: any, i: number) =>
                  i < displayCount && (
                    <div
                      key={i}
                      className="pt-4 spl-community-name font-14 pointer"
                      onClick={(e) => confirmSwitchCommunity(e, item)}
                    >
                      {item.name}
                    </div>
                  )
              )}
            </>
          )}
        </div>

        {/* Show More button for Special Communities */}
        {allSplCommunityList.length > displayCount && (
          <div className="mt-4">
            <Button
              variant="contained"
              size="small"
              color="primary"
              onClick={showMore}
            >
              Show More
            </Button>
          </div>
        )}
      </div>
    </div>
  )}

  {/* STEP 2 */}
  {currentStep === 2 && (
    <div>
      {/* ✅ Base Community */}
      {baseCommunity.id > 0 && baseCommunity.id !== defaultCommId && (
        <div
          className="font-24 text-center py-4 pointer"
          onClick={(e) => confirmSwitchCommunity(e, baseCommunity)}
        >
          {baseCommunity.name}
        </div>
      )}

      {/* ✅ Special Communities Grid */}
      <div className="row mx-5">
        {allSplCommunityList.length > 0 &&
          allSplCommunityList.map((item: any, i) => (
            <div
              className="col-4 text-center pt-4 spl-community-list font-15 pointer"
              key={i}
              onClick={(e) => confirmSwitchCommunity(e, item)}
            >
              {item.name}
            </div>
          ))}
      </div>
    </div>
  )}

  {/* Confirm Dialog */}
  <Dialog
    open={confirmOpen}
    maxWidth="sm"
    fullWidth
    onClose={handleDialogClose}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <ConfirmDialog
      message={message}
      handleDialogClose={handleDialogClose}
      onConfirmCallback={onConfirmCallback}
    />
  </Dialog>
</div>

  );
}
export default SpecialCommunities;